export default "__VITE_ASSET__mfm_podd__"